"use strict";
var moment = require('moment');
var zipObject = require('lodash.zipobject');
var map = require('lodash.map');
var uuid = require('uuid');
var buildMomentLocale = function (localeConfig, passedMoment) {
    var localeName = "-module-locale-" + uuid.v4();
    var theMoment = passedMoment || moment;
    moment.locale(localeName, localeConfig);
    return (function () {
        return theMoment.apply(theMoment, arguments).locale(localeName);
    });
};
module.exports = function (localeConfigs) {
    return zipObject(map(localeConfigs, function (localeConfig, localeName) {
        return [localeName, buildMomentLocale(localeConfig)]
    }));
}



//////////////////
// WEBPACK FOOTER
// ./~/moment-locale-builder/moment-locale-builder.js
// module id = 139
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56